
// Remove prev api call stack which did not get response. handled in src/index.js 
export const apiCallStackDiscardation = store => next => action => {
    if(!action.copyError) {
        return next(action)
    }
}


// WEBPACK FOOTER //
// ./src/Middleware/apiCallStackDiscardation.middleware.js